import { render, staticRenderFns } from "./OrderCenter.vue?vue&type=template&id=3036b729&scoped=true&"
import script from "./OrderCenter.vue?vue&type=script&lang=js&"
export * from "./OrderCenter.vue?vue&type=script&lang=js&"
import style0 from "./OrderCenter.vue?vue&type=style&index=0&id=3036b729&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3036b729",
  null
  
)

export default component.exports